import { removeCookie } from './cookieUtils';

/**
 * Clears all authentication data including tokens and cookies
 */
export const clearAuthData = () => {
  // Clear localStorage
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
  localStorage.clear();

  // Clear all cookies using utility
  removeCookie('access_token');
  removeCookie('refresh_token');
  removeCookie('ElevateToken');
  removeCookie('token');
  removeCookie('session_id');

  // Generic cookie clearing fallback
  document.cookie.split(';').forEach((cookie) => {
    const eqPos = cookie.indexOf('=');
    const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
  });
};

/**
 * Logs out the user by clearing auth data and redirecting to login
 */
export const redirectToLogin = (redirectUrl?: string) => {
  const signInRedirect =
    redirectUrl ||
    process.env.REACT_APP_AUTH_REDIRECT ||
    process.env.REACT_APP_AUTH_REDIRECT || 'https://guiding-hedgehog-41.accounts.dev/sign-in';

  // Clear auth data before redirecting
  clearAuthData();

  // Redirect to login
  window.location.href = signInRedirect;
};
